export default {
  release: '17.8',
  date: 'January 2025',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-8-released/#this-months-notable-contributor',
  contributors: [
    {
      name: 'Océane Legrand',
      gitlabUsername: 'oceane_legrand',
    },
    {
      name: 'Juan Pablo Gonzalez',
      gitlabUsername: 'ScanianJP',
    },
  ],
  writeUp: `Through the Co-Create Program, Océane Legrand has been leading efforts to enhance the Conan package registry feature set, collaborating with Juan Pablo Gonzalez.
Their work has focused on bringing the feature closer to GA readiness while implementing Conan version 2 support.
This collaboration demonstrates how the Co-Create Program can drive significant improvements to GitLab's package registry capabilities.

They were nominated by [Raimund Hook](https://gitlab.com/stingrayza), Senior Fullstack Engineer, Contributor Success at GitLab, who highlighted their persistent collaboration and continuous iteration on the Conan Package Registry features.
Their work exemplifies GitLab values and will benefit all Conan users on the platform.

Océane Legrand is a Full Stack Developer at Scania where she works on maintaining their self-hosted GitLab instance on AWS.
"The work I'm doing in open source impacts both GitLab and Scania," says Océane.
"Contributing through the Co-Create Program has given me new skills, like experience with Ruby and background migrations. When my team at Scania faced an issue during an upgrade, I was able to help troubleshoot because I'd already encountered it through the program."

[Learn more about GitLab's Co-Create Program](https://about.gitlab.com/community/co-create/) where customers work directly with our product and engineering teams to develop new features and enhance existing ones.`,
};
